import {Grid} from '@mui/material';
import AccountDropdownButton from '../../components/accountDropdownButton/AccountDropdownButton';
import {HookAccountToken} from '../../hook/useGetAllAccountToken';
import {firebaseAuth} from '../../setup/firebase';
import {linkEtsyAccount} from '../../util/etsy/linkEtsyAccount';

export interface EtsyPageHeaderProps {
  accounts: HookAccountToken[];
  refetchAccounts: () => void;
  selectedAccount: HookAccountToken | undefined;
  setSelectedAccount: (account: HookAccountToken) => void;
}

export default function EtsyHeader({
  accounts,
  refetchAccounts,
  selectedAccount,
  setSelectedAccount,
}: EtsyPageHeaderProps) {
  return (
    <Grid container direction="row">
      <AccountDropdownButton
        items={accounts}
        selectedItem={selectedAccount}
        setSelectedItem={setSelectedAccount}
        onLink={async () => {
          const token = await firebaseAuth.currentUser?.getIdToken();
          if (!token) {
            return;
          }
          linkEtsyAccount(token, () => refetchAccounts());
        }}
      />
    </Grid>
  );
}
